"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPayload = exports.jsonPathToValue = exports.extractVersionFromString = exports.isGreatherThanOrEqualGivenVersion = exports.cleanUpSpecialChars = exports.haversineDistanceInKm = exports.headersToUserSession = exports.isEmpty = void 0;
var semver = require('semver');
/**
 * Useful method to check if a value is empty
 * @method isEmpty
 * @param {String | Number | Object} value
 * @returns {Boolean} true & false
 * @description this value is Empty Check
 */
var isEmpty = function (value) {
    if (value === null) {
        return true;
    }
    else if (typeof value !== 'number' && value === '') {
        return true;
    }
    else if (typeof value === 'undefined' || value === undefined) {
        return true;
    }
    else if (value !== null && value.constructor === Object && Object.keys(value).length === 0) {
        return true;
    }
    else {
        return false;
    }
};
exports.isEmpty = isEmpty;
/**
 * Transform headers to UserSession object
 * @param headers
 * @returns
 */
var headersToUserSession = function (headers) {
    if (!headers['ac-session-id']) {
        return null;
    }
    var session = {
        id: parseInt(headers['ac-session-id'].toString()),
        type: headers['ac-user-type'].toString(),
        userKeyStr: headers['ac-user-key'].toString(),
        userTypeKeyStr: headers['ac-user-type-key'].toString(),
        accountKeyStr: headers['ac-user-account-key'].toString(),
        allocabAdmin: false,
        admin: false,
    };
    if (!(0, exports.isEmpty)(headers['ac-user-kind'])) {
        session.kind = headers['ac-user-kind'].toString();
    }
    if (!(0, exports.isEmpty)(headers['ac-admin'])) {
        if (headers['ac-admin'].toString() === 'true') {
            session.allocabAdmin = true;
            session.level = parseInt(headers['ac-admin-level'].toString());
        }
    }
    if (!(0, exports.isEmpty)(headers['ac-account-admin'])) {
        if (headers['ac-account-admin'].toString() === 'true') {
            session.admin = true;
        }
    }
    if (headers['ac-app-token']) {
        session.appToken = headers['ac-app-token'];
    }
    if (headers['ac-access-token']) {
        session.accessToken = headers['ac-access-token'];
    }
    if (headers['ac-user-full-name']) {
        var str = headers['ac-user-full-name'].toString();
        //Used to convert ascii char present with special char
        session.userFullName = JSON.parse('"' + str.replace(/\"/g, '\\"') + '"')
            .toString()
            .replaceAll('"', '');
    }
    return session;
};
exports.headersToUserSession = headersToUserSession;
/**
 * Calculates a simple distance between 2 points in KM
 * @param param0
 * @param param1
 * @returns
 */
var haversineDistanceInKm = function (_a, _b) {
    var lat1 = _a[0], lon1 = _a[1];
    var lat2 = _b[0], lon2 = _b[1];
    var toRadian = function (angle) { return (Math.PI / 180) * angle; };
    var distance = function (a, b) { return (Math.PI / 180) * (a - b); };
    var RADIUS_OF_EARTH_IN_KM = 6371;
    var dLat = distance(lat2, lat1);
    var dLon = distance(lon2, lon1);
    lat1 = toRadian(lat1);
    lat2 = toRadian(lat2);
    // Haversine Formula
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.asin(Math.sqrt(a));
    var finalDistance = RADIUS_OF_EARTH_IN_KM * c;
    return finalDistance;
};
exports.haversineDistanceInKm = haversineDistanceInKm;
/**
 * Removes chars from string
 * @param str
 * @returns
 */
var cleanUpSpecialChars = function (str) {
    return str
        .replace(/[ÀÁÂÄàáâä]/g, 'a')
        .replace(/[ÈÉÊËéèêë]/g, 'e')
        .replace(/[^a-z0-9 ]/gi, ' ')
        .replace(/ +(?= )/g, '');
};
exports.cleanUpSpecialChars = cleanUpSpecialChars;
var isGreatherThanOrEqualGivenVersion = function (currentVersion, givenVersion) {
    if (!currentVersion || !givenVersion) {
        return false;
    }
    return semver.satisfies(currentVersion, '>=' + givenVersion);
};
exports.isGreatherThanOrEqualGivenVersion = isGreatherThanOrEqualGivenVersion;
/**
 * Extracts a version from a string
 * Returns version with format x.x.x only
 * Returns an empty string if a version is not found
 * @param data
 * @returns
 */
var extractVersionFromString = function (data) {
    if (!data) {
        return '';
    }
    var result = data.match(/\d+(\.\d+)+/);
    if (!result || result.length === 0) {
        return '';
    }
    return result[0];
};
exports.extractVersionFromString = extractVersionFromString;
/**
 * Used to navigate in a JSON  using path like user.account.name
 * @param jsonData : JSON Object
 * @param path : paht with x.x.x.n format
 * @returns
 */
var jsonPathToValue = function (jsonData, path) {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    path = path.replace(/^\./, '');
    var pathArray = path.split('.');
    for (var i = 0, n = pathArray.length; i < n; ++i) {
        var key = pathArray[i];
        if (key in jsonData) {
            if (jsonData[key] !== null) {
                jsonData = jsonData[key];
            }
            else {
                return null;
            }
        }
        else {
            return key;
        }
    }
    return jsonData;
};
exports.jsonPathToValue = jsonPathToValue;
/**
 * Used to log a payload and format it without sensitive data
 * @param payload
 * @returns
 */
var formatPayload = function (payload) {
    if ((0, exports.isEmpty)(payload)) {
        return null;
    }
    var copy = __assign({}, payload);
    if (copy.password) {
        copy.password = '*';
    }
    if (copy.login) {
        copy.login = '*';
    }
    if (copy.email) {
        copy.email = '*';
    }
    if (copy.accessToken) {
        copy.accessToken = '*';
    }
    if (copy.refreshToken) {
        copy.refreshToken = '*';
    }
    if (copy.jwt) {
        copy.jwt = '*';
    }
    if (copy.googleToken) {
        copy.googleToken = '*';
    }
    if (copy.microsoftToken) {
        copy.microsoftToken = '*';
    }
    if (copy.codeToValidate) {
        copy.codeToValidate = '*';
    }
    return JSON.stringify(copy);
};
exports.formatPayload = formatPayload;
